import script from "./RemoteDigitalSignatureForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RemoteDigitalSignatureForm.vue?vue&type=script&setup=true&lang=js"

import "./RemoteDigitalSignatureForm.vue?vue&type=style&index=0&id=1a72ca66&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a72ca66"]])

export default __exports__